import React, { useState, useEffect } from 'react';
import Fingerprint2 from 'fingerprintjs2';
import { Button, Col } from 'reactstrap';
import WafCaptcha from '../../components/WafCaptcha/WafCaptcha';
import axios from '../../axios-base';

const FingerprintVote = (props) => {
    const [fingerprint, setFingerprint] = useState('');
    const [votingButton, setVotingButton] = useState('Jetzt abstimmen!');
    const [votingReady, setVotingReady] = useState(true);
    const [captchaContainerVisibility, setCaptchaContainerVisibility] = useState(false);

    useEffect(() => {
        const options = {};
        Fingerprint2.getPromise(options).then((components) => {
            const values = components.map(({ value }) => value).join('');
            const hash = Fingerprint2.x64hash128(values, 31);
            setFingerprint(hash);
        });
    }, []);

    const onVoteHandler = () => {
        fingerprintVote();
    };

    const fingerprintVote = () => {
        const { id } = props.match.params;
        axios
            .patch(
                `/projects/${id}/vote`,
                {
                    fingerprint: fingerprint,
                },
                { wafProtected: true }
            )
            .then((response) => {
                if (response.status === 200) {
                    setCaptchaContainerVisibility(false);
                    setVotingReady(false);

                    if (response !== undefined) {
                        setVotingButton('Vielen Dank für Ihre Stimme!');
                        props.history.push('/stimme-bestaetigt');
                    } else {
                        setVotingButton('Sie haben bereits abgestimmt!');
                        handleUnsuccessfulFingerprintVote(response);
                    }
                } else {
                    handleUnsuccessfulFingerprintVote(response);
                }
            })
            .catch((err) => {
                if (err.response.status === 405) {
                    setCaptchaContainerVisibility(true);
                } else {
                    handleUnsuccessfulFingerprintVote(err);
                }
            });
    };

    const onCaptchaVerified = () => {
        setCaptchaContainerVisibility(false);
        onVoteHandler();
    };

    const handleUnsuccessfulFingerprintVote = (responseOrError) => {
        console.error(responseOrError);
    };

    return (
        <Col xs="12" sm="6" lg="12">
            <WafCaptcha show={captchaContainerVisibility} onVerified={onCaptchaVerified} />
            {!captchaContainerVisibility && (
                <Button
                    className={votingReady ? 'anl_fp--vote' : null}
                    block
                    disabled={!votingReady}
                    color="primary"
                    onClick={onVoteHandler}
                >
                    {votingButton}
                </Button>
            )}
        </Col>
    );
};

export default FingerprintVote;
